module.exports = __webpack_public_path__ + "02_very_short_brown.e38ac2ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_very_short_brown.png
// module id = xQWn
// module chunks = 0